export const auditLogKeys = {
  all: ['audit-log'] as const,
  byWorkOrder: (workOrderId: string) => [...auditLogKeys.all, 'work-order', workOrderId] as const,
};
